import { ReactElement } from 'react';
import { Route } from 'react-router';
import { SwitchWithNotFound } from '../containers/SwitchWithNotFound';
import { NotFoundView } from '../views/errors/NotFound.view';
import { FreeAccessViewImageView } from '../views/home/freeAccessAnnotations/freeAccessViewImage.view';
import { Home } from './config/Home';

export const FreeAccessRoute = (): ReactElement => (
  <SwitchWithNotFound notFound={<NotFoundView />}>
    <Route path={Home.FreeAccess.View.Path}>
      <FreeAccessViewImageView />
    </Route>
  </SwitchWithNotFound>
);
